import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import "./index.css";
import App from "./App";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/index";

// Import reselect shim to force webpack to bundle createSelector
// Webpack 5 treats .cjs files as static assets, so reselect (which ships as .cjs)
// gets emitted to /static/media/ instead of being bundled as JS code.
// This import ensures createSelector is available at runtime for recharts.
import "./lib/reselect-shim";

// Unregister ALL service workers to prevent stale cache issues
// SW causes black screen when old cached chunks don't match new index.html
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(reg => reg.unregister().catch(() => {}));
  });
}
function RootLoader() {
  return (
    <div style={{
      position: "fixed", inset: 0, display: "flex", alignItems: "center",
      justifyContent: "center", background: "#09090B", color: "#f59e0b",
      fontFamily: "'IBM Plex Mono', monospace", fontSize: 12,
      letterSpacing: "0.2em", textTransform: "uppercase",
    }}>
      <div style={{
        width: 32, height: 32, border: "2px solid #333",
        borderTopColor: "#f59e0b", borderRadius: "50%",
        animation: "spin 0.8s linear infinite",
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <React.Suspense fallback={<RootLoader />}>
        <App />
      </React.Suspense>
    </I18nextProvider>
  </React.StrictMode>
);
